import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';
import { LookupType } from 'app/enum/Particles';
import { TweenLookupTable, TweenLookupTableParams } from 'particles/lookups/TweenLookupTable';

export class IconLookup implements particles.ParticleLookup {
	private _path: Array<particles.ParticleLookupProps> = [];

	constructor() {
		let steps: number = 1000;

		let targetPoints: Array<TweenLookupTableParams> = [
			{ start: { x: -0.15, y: -0.03 }, end: { x: 0.01, y: 1.09 }, pointCount: Math.round(steps * 0.25) },
			{ start: { x: 0.01, y: 1.09 }, end: { x: 1.2, y: 0.45 }, pointCount: Math.round(steps * 0.25) },
			{ start: { x: 1.2, y: 0.45 }, end: { x: 0.5, y: 0.2 }, pointCount: Math.round(steps * 0.12) },
			{ start: { x: 0.5, y: 0.2 }, end: { x: 0.3, y: 0.37 }, pointCount: Math.round(steps * 0.06) },
			{ start: { x: 0.3, y: 0.37 }, end: { x: 0.52, y: 0.46 }, pointCount: Math.round(steps * 0.05) },
			{ start: { x: 0.52, y: 0.46 }, end: { x: 0.2, y: 0.67 }, pointCount: Math.round(steps * 0.1) },
			{ start: { x: 0.2, y: 0.67 }, end: { x: 0.15, y: 0.065 }, pointCount: Math.round(steps * 0.15) },
			{ start: { x: 0.15, y: 0.065 }, end: { x: -0.15, y: -0.03 }, pointCount: Math.round(steps * 0.08) }
		];

		let lookup: TweenLookupTable = new TweenLookupTable();
		let tweenPoints: Array<geometry.Vector2> = lookup.multiTween(targetPoints);

		tweenPoints.forEach((point: geometry.Vector2, index: number) => {
			Math.abs(index - steps / 2) / (steps / 2);
			this._path.push({
				x: point.x,
				y: point.y,
				scale: 0.5,
				alpha: 1,
				rotation: 0
			});
		});
	}

	public get type(): LookupType {
		return LookupType.ICON;
	}

	public get total(): number {
		return this._path.length;
	}

	public get table(): Array<particles.ParticleLookupProps> {
		return this._path;
	}

	public get(index: number): particles.ParticleLookupProps {
		return this._path[index];
	}
}
